
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

import { useData } from '../hooks/DataProvider';

import translations from '../scripts/translations';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '1px solid #000',
    borderRadius: '8px',
    boxShadow: 24,
    p: 4,
};

const Popup = ({ popupData, setPopupData }) => {

    const { open, code, id, fn } = popupData;

    const { language } = useData();

    const popupText = translations.popups[code][language] || {
        title: '',
        message: '',
        confirmButton: 'OK',
        cancelButton: 'Cancel',
    };

    const handleClose = (bool) => {

        if (bool) {
            fn(id);
        }

        setPopupData({
            open: false,
            code: null,
            id: null,
            fn: null,
            types: {
                hasCancel: false,
                hasConfirm: false,
            }
        }); // Close the popup


    };


    return (
        <div>

            <Modal
                open={!!open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                {open &&  <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        {popupText.title}
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                        {popupText.message}
                    </Typography>

                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                        {popupData.types.hasConfirm &&
                            <Button variant="contained" color="primary" onClick={() => handleClose(true)}>
                                {popupText.confirmButton}
                            </Button>}

                        {popupData.types.hasCancel &&
                            <Button variant="outlined" color="secondary" onClick={() => handleClose(false)} sx={{ ml: 2 }}>
                                {popupText.cancelButton}
                            </Button>}
                    </Box>

                </Box>}
            </Modal>
        </div>
    );

};

export default Popup;